module.exports = __webpack_public_path__ + "static/media/5closeupbodyIMG_3529.267e1382.jpg";